import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {
	TextInput,
	TextArea,
	DatePicker,
	RadioList,
	FileUpload,
	ImageUpload,
	Select,
	ToggleButton,
	Checkbox,
	Number
} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import {ModalWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import FormToolbar from '../../components/ButtonToolbar';
import DriverLookup from '../../components/Form/DriverLookup';
import GroupsInput from '../../components/Form/GroupsInput';
import TrainingTypeSelect from "../../components/Form/TrainingTypeSelect";
import Client from "../../helpers/ApiClient";
import IconCheckbox from "../../components/Form/IconCheckbox";
import ClientLookup from "../../components/Form/ClientLookup";
import DriverSubform from "./DriverSubform";
import immutable from "immutable";
import DriverList from "../Driver/PickerList";
import DriverForm from "../Driver/Form";

class ItemSubform extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td><FormField name="trainingtype"/></td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid),
			trainingTypes: state.dbinfo.trainingType
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true})
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'order.fetch',
			save: 'order.save',
			remove: 'order.delete'
		};

		this.changeEvent = 'order.change';

		this.messages = {
			remove: 'Opravdu si přejete objednávku odstranit?',
			notfound: 'Objednávka nenalezena!'
		};

		this.schema = {
			/*driver: {
				label: 'Řidič',
				class: DriverLookup,
				rules: {
					presence: {message: 'Řidič je povinná položka!'}
				}
			},*/
			personal: {
				class: Select,
				label: 'Typ školení',
				clearable: false,
				options: DbInfo.OrderPersonal,
				value: 1
			},
			items: {
				class: Multiform,
				className: 'drivers multiform',
				label: 'Položky',
				addLabel: false,
				subform: DriverSubform,
				showCreateTraining: this.props.id > 0,
				trainingTypes: this.props.trainingTypes,
				onCreateTraining: (driver) => {
					this.handleCreateTrainingDriver(driver);
				},
				beforeChange: (key, val, values) => {
					if (key === 'trainingtype') {
						return values.set('price', this.props.trainingTypes.filter((item) => item.id == val)[0].price * 1.21);
					}
					else {
						return values;
					}
				},
				schema: {
					ev: {
						class: TextInput,
						label: 'Ev.č.'
					},
					surname: {
						class: TextInput,
						label: 'Příjmení'
					},
					name: {
						class: TextInput,
						label: 'Jméno'
					},
					trainingtype: {
						class: TrainingTypeSelect,
						style: {width: 150},
						clearable: false,
						label: 'Druh školení',
						rules: {
							presence: {message: 'Druh školení je povinná položka!'}
						}
					},
					price: {
						class: Number,
						style: {width: 70},
						label: 'Cena'
					},
					groups1: {
						class: GroupsInput,
						label: 'Skupiny I.'
					},
					groups2: {
						class: GroupsInput,
						label: 'Skupiny II.'
					},
					training: {
						class: TextInput,
						style: {width: 60},
						visible: true,
						label: 'Školení'
					}
				}
			},
			firm: {
				class: ClientLookup,
				visible: (form) => {
					return form.personal == 2
				},
				label: 'Firma',
			},
			firm_text: {
				class: TextInput,
				visible: (form) => {
					return form.personal == 2
				},
				label: 'Firma zadaná uživatelem',
			},
			/*trainingtype: {
				class: TrainingTypeSelect,
				label: 'Druh školení',
				rules: {
					presence: {message: 'Druh školení je povinná položka!'}
				}
			},
			price: {
				class: Number,
				label: 'Cena'
			},*/
			/*praxe: {
				class: IconCheckbox,
				label: 'Praktický zácvik',
				value: 0
			},
			price_praxe: {
				class: Number,
				label: 'Cena za zácvik'
			},*/
			status: {
				class: Select,
				options: DbInfo.OrderStatus,
				label: 'Stav',
				value: 1
			},
			/*op_a: {
				class: ToggleButton,
				title: 'A',
			},
			op_b: {
				class: ToggleButton,
				title: 'B',
			},
			op_c: {
				class: ToggleButton,
				title: 'C',
			},
			op_d: {
				class: ToggleButton,
				title: 'D',
			},
			op_e: {
				class: ToggleButton,
				title: 'E',
			},
			op_f: {
				class: ToggleButton,
				title: 'F',
			},
			op_g: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m: {
				class: ToggleButton,
				title: 'M',
			},
			op_z: {
				class: ToggleButton,
				title: 'Z',
			},

			op_a_2: {
				class: ToggleButton,
				title: 'A',
			},
			op_b_2: {
				class: ToggleButton,
				title: 'B',
			},
			op_c_2: {
				class: ToggleButton,
				title: 'C',
			},
			op_d_2: {
				class: ToggleButton,
				title: 'D',
			},
			op_e_2: {
				class: ToggleButton,
				title: 'E',
			},
			op_f_2: {
				class: ToggleButton,
				title: 'F',
			},
			op_g_2: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1_2: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2_2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m_2: {
				class: ToggleButton,
				title: 'M',
			},
			op_z_2: {
				class: ToggleButton,
				title: 'Z',
			},*/
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: '#' + data.id});
	}

	handleCreateTraining() {
		const api = new Client();
		api.call('order.createTraining', {id: this.props.id}, {progress: true}).then((data) => {
			this.form.setValue(data.form.form);
			if (data.message) {
				const alert = new AlertWindow('Chyba', <span dangerouslySetInnerHTML={{__html: data.message}} />);
				alert.show(this.context.store.dispatch);
			} else {
				this.context.flashMessage({message: 'Školení bylo založeno.'});
			}
		});
	};

	handleCreateTrainingDriver(driver) {
		const api = new Client();
		api.call('order.createTrainingDriver', {id: this.props.id, driver: driver}, {progress: true}).then((data) => {
			this.form.setValue(data.form.form);
			if (data.message) {
				const alert = new AlertWindow('Chyba', <span dangerouslySetInnerHTML={{__html: data.message}} />);
				alert.show(this.context.store.dispatch);
			} else {
				this.context.flashMessage({message: 'Školení bylo založeno.'});
			}
		});
	};

	handlePrint(type) {
		const api = new Client();
		api.call('order.download', {id: this.props.id, type}, {progress: true}).then((data) => {
			if (data) {
				var win = window.open(data.url, '_blank');
				if (win) {
					win.focus();
				} else {
					alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
				}
				//window.location = data.url;
			}
		});
	};

	handlePrintFA(type) {
		const api = new Client();
		api.call('order.downloadFA', {id: this.props.id, type}, {progress: true}).then((data) => {
			if (data) {
				var win = window.open(data.url, '_blank');
				if (win) {
					win.focus();
				} else {
					alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
				}
				this.setState({existFA: true});
				//window.location = data.url;
			}
		});
	};

	handleAddDriver(driver) {
			let drivers = this.form.getValues().get('items');
			if (!drivers) {
				drivers = immutable.List();
			}
			drivers = drivers.push({
				id: -Math.random(),
				driver: driver.id,
				name: driver.name,
				surname: driver.surname,
				ev: driver.ev
			});
			this.form.setValue({items: drivers.toJS()});
	}

	pickDriver(type = 1) {
		let firm = this.form.getValues().getIn(['firm', 'text']);
		this.popupDriver = new ModalWindow(null, <DriverList firm={firm} onAdd={(text) => this.handleAddDriver(text, type)} />);
		this.popupDriver.className = 'wide950';
		this.popupDriver.show(this.context.store.dispatch);
	}

	handleNewDriver() {
		let firm = this.form.getValues().get('firm');
		this.newDriver = new ModalWindow('Nový řidič', <DriverForm firm={firm ? firm.toJS() : null} popup={true} onClose={() => this.handleHideNewDriver()} onSave={(driver) => this.handleSaveDriver(driver)} />);
		this.newDriver.className = 'wide950';
		this.newDriver.show(this.context.store.dispatch);
	}

	handleSaveDriver(driver) {
		this.handleHideNewDriver();
		this.handleAddDriver(driver);
	}

	handleHideNewDriver() {
		this.newDriver.hide();
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;
		const data = this.props.form && this.props.form.get('data')
    const values = this.props.form && this.props.form.get('values')
		const existFA = data && data.get('invoice') || this.state.existFA;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={() => this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Založit školení',
				icon: 'fa fa-plus',
				visible: !isNew,
				bsStyle: 'default',
				onClick: () => this.handleCreateTraining()
			},
			{
				title: 'Daňový doklad',
				icon: !existFA ? 'fa fa-plus' : 'fa fa-file-pdf-o',
				visible: !isNew,
				bsStyle: 'success',
				onClick: () => this.handlePrintFA()
			},
			{
				title: 'Proforma faktura',
				visible: !isNew,
				icon: 'fa fa-file-pdf-o',
				bsStyle: 'success',
				onClick: () => this.handlePrint()
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				visible: !isNew,
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: () => this.remove()
			}
		];
		return (
			<div style={{position: 'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))}/>
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Objednávka">
						<FormToolbar buttons={toolbar}/>
					</Toolbar>
					<div className="row">
						<div className="col-md-12">
							<table className="form">
								<tbody>
								{data &&
								<tr>
									<th>Vytvořeno</th>
									<td>{data.get('created')}</td>
								</tr>}
								{false && <FormRow name="driver" labelWidth={120}/>}
								<FormRow name="personal" labelWidth={170}/>
                {values && values.get('personal') == 2 &&
                <tr>
                  <th>Firma</th>
                  <td>
                    <FormField name="firm" visible={this.schema.firm.visible}/>
                    {values && values.get('firm_text') && values.get('firm_text').length &&
                    <div style={{marginTop: 10}}>
                     firma zadaná uživatelem: {values.get('firm_text')}
                    </div>}
                  </td>
                </tr>}
								<FormRow label="Položky">
									<FormField name="items" />
									<ButtonToolbar style={{float:'none', margin:'10px 0px'}}>
										<Button onClick={() => this.handleNewDriver()}><span className="fa fa-plus position-left"></span>nový řidič</Button>
										<Button onClick={() => this.pickDriver()}><span className="fa fa-hand-pointer-o position-left"></span>vybrat z evidence</Button>
									</ButtonToolbar>
								</FormRow>
								{false &&<FormRow name="trainingtype"/>}
								{false && <FormRow name="price"/>}
								{false && <tr>
									<th>Skupiny I.</th>
									<td className="toggles">
										<FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/>
										<FormField name="op_d"/> <FormField name="op_e"/> <FormField name="op_f"/>
										<FormField name="op_g"/> <FormField name="op_w1"/> <FormField name="op_w2"/>
										<FormField name="op_m"/> <FormField name="op_z"/>
									</td>
								</tr>}
								{false && <tr>
									<th>Skupiny II.</th>
									<td className="toggles">
										<FormField name="op_a_2"/> <FormField name="op_b_2"/> <FormField name="op_c_2"/>
										<FormField name="op_d_2"/> <FormField name="op_e_2"/> <FormField name="op_f_2"/>
										<FormField name="op_g_2"/> <FormField name="op_w1_2"/> <FormField
										name="op_w2_2"/> <FormField name="op_m_2"/> <FormField name="op_z_2"/>
									</td>
								</tr>}

								<FormRow name="status"/>
								{data &&
								<tr>
									<th>Číslo objednávky</th>
									<td>{data.get('vs')}</td>
								</tr>}
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Order/Form.js